<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    :maskClosable="false"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <def-register-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></def-register-form>
    <template slot="footer">
        <a-button key="back" @click="handleCancel">关闭</a-button>
        <a-button key="submit" type="primary" @click="handleOk" title="新增,未发布">先保存,需要观察</a-button>
        <a-button key="register" type="primary" @click="handleRegister" title="新增,发布">登记缺陷</a-button>
    </template>
  </j-modal>
</template>

<script>

  import DefRegisterForm from './DefRegisterForm'
  export default {
    name: 'DefRegisterModal',
    components: {
      DefRegisterForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (devId) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(devId);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      handleRegister () {
        this.$refs.realForm.registerForm();
      },
      submitCallback(defRegisterId){
        this.$emit('ok',defRegisterId);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>